export var AgreementChangeType = /*#__PURE__*/ function(AgreementChangeType) {
    AgreementChangeType["CoverCreditCardFees"] = "creditCardFeesCoverChangeData";
    AgreementChangeType["CoverDirectDebitFees"] = "directDebitFeesCoverChangeData";
    AgreementChangeType["NetTerms"] = "netTermsChangeData";
    AgreementChangeType["AmendmentsApprovalMethod"] = "amendmentsApprovalMethodChangeData";
    AgreementChangeType["InvoicesApprovalMethod"] = "invoicesApprovalMethodChangeData";
    AgreementChangeType["BillingDayOfWeek"] = "relationshipBillingDayOfWeekChangeData";
    AgreementChangeType["legalTermsDocuments"] = "legalTermsDocumentsChangeData";
    AgreementChangeType["Services"] = "serviceChangeData";
    AgreementChangeType["ManualPayments"] = "manualPaymentsChangeData";
    AgreementChangeType["Title"] = "titleChangeData";
    AgreementChangeType["Seller"] = "sellerChangeData";
    AgreementChangeType["ServiceQboClass"] = "serviceIntegrationClassChangeData";
    AgreementChangeType["CustomPages"] = "customPagesChangeData";
    return AgreementChangeType;
}({});
